import Vue from 'vue'
import Button3d from './Button3d.vue'

Vue.component('Button3d', Button3d)
